goog.provide('el8.data.decisionSupports');

goog.require('el8.appchart.cqmRefresh');
goog.require('el8.appchart.refpanel.maintItems');
goog.require('el8.appchart.dialog.smokingStatus');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.visitNote.exportProblemsDialog');
goog.require('el8.app.shared.dialog.reportAttachments');
goog.require('el8.data.icd10Codes');
goog.require('el8.data.maintItemRules');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.order');
goog.require('el8.service.urls');
goog.require('el8.template.render.decisionSupports');
goog.require('el8.util.amplitude.letterHelpers');
goog.require('el8.appchart.mgr.notes');

/**
 * This model represents the set of potential CDS (Clinical Decision Support)
 * items that a practice supports. Some of these are global (CQM related)
 * and some are custom to a practice.
 */
el8.data.decisionSupports = (function() {

    /*
     * The result of picking a CDS response:
     * instructions to add doctags, add note text, create an order, etc.
     */
    var _responseResultClass = function(spec) { this.populate(spec); };
    _responseResultClass.inheritsFrom(el8_Entity);

    _responseResultClass.addStringProperty('type');
    _responseResultClass.addStringProperty('subType');
    // this is a JSON dict containing:
    //  - tag_concepts for type 'doctags'
    //  - codes for type 'doctags_by_code'
    //  - parent_text + child_text for type 'note_bullets'
    //  - text for type 'note_text', 'message'
    //  - (optional) text for type 'order'
    //  - (optional) target for type 'manual_lab_entry'. target should be
    //    a labTest code like 'elation-hemoglobina1c-hemoglobina1c'
    // and is empty for other types
    _responseResultClass.addProperty('metadata');

    // Holds all the logic for what it means to take a particular action
    // (add text to the note, open an order, etc.)
    _responseResultClass.prototype.takeAction = function(noteFormObj) {
        if (this.getType() === 'doctags') {
            el8.data.docTags.fetchByConceptNamesV2(this.getMetadata().tag_concepts, function(tagIds) {
                noteFormObj.addDocumentTags(tagIds);
            });
        } else if (this.getType() === 'doctags_by_code') {
            // This action does not use the doctag "concept name", uh, concept,
            // but rather does a look up by code. We also only want these to be
            // applied only to the note not injected into the bill hence the use
            // of note.saveDocTags
            el8.data.docTags.fetchByCodes(this.getMetadata().codes, function(tagIds) {
                var note = noteFormObj.getNote();
                // saveDocTags clears existing... do union
                note.saveDocTags(_.union(note.getDocTagIds(), tagIds), {
                    successCb: function(data) {
                        noteFormObj._populateDocTagsWithTooltips();
                    }
                });
            });
        } else if (this.getType() === 'note_text') {
            var text = this.getMetadata().text;
            var section = this.getSubType();
            noteFormObj.addText(text, section);

        } else if (this.getType() === 'manual_lab_entry') {
            var target = null;
            var metadata = this.getMetadata();
            if (metadata) { target = metadata.target; }
            el8.appchart.dialog.manualLabEntry.show({'target': target});

        } else if (this.getType() === 'note_bullets') {
            var goal = this.getMetadata().parent_text;
            var text = this.getMetadata().child_text;
            var section = this.getSubType();

            if(text && text.length) {
                noteFormObj.addParentChild({ 'text': goal }, { 'text': text }, section);
            }
            else {
                noteFormObj.addParentChild({ 'text': goal }, null, section);
            }

        } else if (this.getType() === 'billing_cpt') {
            var codes = this.getMetadata().cpt_codes;
            if (codes) {
                _(codes).each(function(code) {
                    noteFormObj.appendBillingCpt({code: code});
                });
            }

            // Support billing CPT code with diagnostics associated in ICD-10 format
            // {
            //    cpt_code: XXX,
            //    icd10_codes: [III, IIII, IIIII]
            //  }
            var code_maps = this.getMetadata().code_maps;
            if (code_maps) {
                _(code_maps).each(function(code_map) {
                    noteFormObj.appendBillingCpt({code: code_map.cpt_code});

                    var dxMap = [];
                    if (code_map.icd10_codes) {
                        _(code_map.icd10_codes).each(function(icd10Code) {
                            var map = {
                                icd10Code: el8.data.icd10Codes.getByKey(icd10Code).asSoyMap()
                            };
                            dxMap.push(map);
                        });
                    }

                    if (dxMap.length > 0) {
                        noteFormObj.appendBillingDxMaps(dxMap);
                    }
                });
            }

        } else if (this.getType() === 'note_dx') {
            // This is actually added to billing not to the body of the note
            // it only adds the Dx code to the last CPT code added to the billing section
            var icd10_ids = this.getMetadata().icd10_ids; // DEPRECATED: use icd10_codes instead
            var icd10_codes = this.getMetadata().icd10_codes;

            var dxMap = [];
            if (icd10_ids) {
                _(icd10_ids).each(function(icd10Id) {
                    var map = {
                        icd10Code: el8.data.icd10Codes.getById(icd10Id).asSoyMap()
                    };
                    dxMap.push(map);
                });

            } else if (icd10_codes) {
                _(icd10_codes).each(function(icd10Code) {
                    var map = {
                        icd10Code: el8.data.icd10Codes.getByKey(icd10Code).asSoyMap()
                    };
                    dxMap.push(map);
                });
            }

            if (dxMap.length > 0) {
                noteFormObj.appendBillingDxMaps(dxMap);
            }

        } else if (this.getType() === 'problem') {
            var searchTerm;
            if (this.getMetadata().searchTerm) {
                searchTerm = this.getMetadata().searchTerm;
            } else if (this.getMetadata().codes) {
                searchTerm = this.getMetadata().codes;
            }
            el8.appchart.dialog.addEditProblem.show({
                defaultSearch: searchTerm
            });

        } else if (this.getType() === 'problem_with_assessment_billing') {
            var searchTerm = this.getMetadata().searchTerm;

            var saveprobCb = function (problem) {
                el8.appchart.mgr.notes.addReference({item: problem, sectionName: 'assessment'});
                el8.appchart.mgr.notes.appendBillingDiagnoses({imoIds: problem.getImoIds()});
            };

            el8.appchart.dialog.addEditProblem.show({
                defaultSearch: searchTerm,
                saveCb: saveprobCb
            });

        } else if (this.getType() === 'dedupe_problem_with_assessment_billing') {
            var searchTerm1 = this.getMetadata().searchTerm;

            var addToNote = function(theProblem) {
                el8.appchart.mgr.notes.addReference({item: theProblem, sectionName: 'assessment'});
                el8.appchart.mgr.notes.appendBillingDiagnoses({imoIds: theProblem.getImoIds()});
            };

            var activeProblems = el8.ptdata.ptProblems.getAllActive();
            var existingProblem = null;
            for (var i = 0; i < activeProblems.length; ++i) {
                var problem = activeProblems[i];
                var imoCodes = [];
                /*
                 * Each imo code object has a list of icd10s associated with it. Flattening into a single list of codes
                 */
                problem.getImoCodeObjs().forEach(function (obj) {
                    obj._icd10Codes.forEach(function (code) {
                        imoCodes.push(code)
                    })
                })
                /*
                 * search term is technically an array. This will usually be an array of length 1, but just in case it
                 * isn't, ensure all terms appear in the icd10 list
                 */
                if (searchTerm1.every(function (term) {
                    return imoCodes.indexOf(term) >= 0}
                )) {
                    existingProblem = problem;
                    break;
                }
            }

            if (!existingProblem) {
                el8.appchart.dialog.addEditProblem.show({
                    defaultSearch: searchTerm1,
                    saveCb: addToNote
                });
            }
            else {
                addToNote(existingProblem)
            }

        } else if(this.getType() === 'note_vitals') {
            noteFormObj._showVitalsSection();

            var focusOn = this.getSubType();
            if (focusOn === 'bmi') {
                noteFormObj._form.getInfoField('weight').getInputField().focusFocus();
            }

            else if (focusOn === 'bp') {
                noteFormObj._form.getInfoField('bpS_0').getInputField().focusFocus();
            }

        } else if (this.getType() === 'order') {
            var orderType = this.getSubType();
            if (orderType === 'PatientImmunization') {
                var dlg = el8Globals.FEATURES.IRSubmissions
                  ? el8.appchart.dialog.addEditImmunizationNew
                  : el8.appchart.dialog.addEditImmunization;
                dlg.show();

            } else if (orderType === 'PatientAllergy') {
                el8.appchart.dialog.addEditAllergy.show();

            } else if (orderType === 'NKDA') {
                el8.ptdata.ptAllergies.saveAsDocumented();

            } else if (orderType === 'ReferralOrder') {
                // Referral orders close the visit when they open.
                // That's lame. Manually draft a referral in the background.
                var reason = this.getMetadata().text;
                var icd10_codes = this.getMetadata().icd10_codes;

                var referral = el8.ptdata.letters.create({
                    body: reason,
                    letterType: el8.util.consts.REFERRAL_LETTER
                }, true);

                $.el8_ajax(
                    // We can't access a referral order without saving the letter first
                    // So, we:
                    // 1. save-create the referral letter
                    // 2. we create a referral order
                    // 3. we attach the icd10 codes
                    // 4. we save the letter again since the order is attached to it
                    el8.ptdata.letters.saveAjaxArgs(referral, false, {
                        successCb: function() {
                            if (icd10_codes) {
                                var order = referral.getReferralOrder();
                                order.setIcd10Ids(el8.data.icd10Codes.getIdsByKey(icd10_codes));

                                $.el8_ajax(
                                    el8.ptdata.letters.saveAjaxArgs(referral)
                                );
                            }
                            // manually log create referral event since we don't show letter by default
                            el8.util.amplitude.logStartLetter('CDS', el8.util.consts.REFERRAL_LETTER);
                        }
                    })
                );

            } else if (orderType === 'LabOrder') {
                if (this.getMetadata() && this.getMetadata().icd10_codes) {
                    var icd10_codes = this.getMetadata().icd10_codes;
                    var model = el8.ptdata.model.order.lab({model_class: orderType});
                    model.setIcd10Ids(el8.data.icd10Codes.getIdsByKey(icd10_codes));

                    var dg = el8.appchart.mgr.orderForm.showOrderForm(orderType, false, {model: model});
                    dg._extractOrder(model, false);
                    dg._saveOrder(model);

                } else {
                    el8.appchart.mgr.orderForm.showOrderForm(orderType);
                }

            } else if (orderType === 'ImagingOrder') {
                if (this.getMetadata() && this.getMetadata().icd10_codes) {
                    var icd10_codes = this.getMetadata().icd10_codes;
                    var model = el8.ptdata.model.order.imaging({model_class: orderType});
                    model.setIcd10Ids(el8.data.icd10Codes.getIdsByKey(icd10_codes));

                    var dg = el8.appchart.mgr.orderForm.showOrderForm(orderType, false, {model: model});
                    dg.holdOrder(dg.model, dg.dialog, false, true);

                } else {
                    el8.appchart.mgr.orderForm.showOrderForm(orderType);
                }

            } else {
                el8.appchart.mgr.orderForm.showOrderForm(orderType);
            }

        } else if (this.getType() === 'message') {
            el8.appshared.message.prePopulateNewMessage({
                body: this.getMetadata().text
            });

        } else if (this.getType() === 'smoking_status') {
            el8.appchart.dialog.smokingStatus.show();

        } else if (this.getType() === 'mark_meds_documented') {
            el8.appchart.mgr.notes.markCurrentMedsDocumented(true);

        } else if (this.getType() === 'unaddressed_problems') {
            var unaddressedProblems = el8.ptdata.ptProblems.all().filter(function(p) {
                return p.isShowLastFullyAddressedDate();
            });

            el8.appchart.visitNote.exportProblemsDialog.show(unaddressedProblems,
                'Actions to Resolve Clinical Reminder',
                'Chronic conditions have not been addressed this year'
            );
        } else if (this.getType() === 'external_link') {
            var url = this.getMetadata().url;
            window.open(url, '_blank');

        } else if (this.getType() === 'report_doctags') {
            var tags = this.getMetadata().tag_concepts;

            el8.app.shared.dialog.reportAttachments.show({
                callbackFn: function (attachmentItems) {
                    if (attachmentItems.length) {
                        var attachment = attachmentItems[0];

                        if (tags) {
                            el8.data.docTags.fetchByConceptNames(tags, function(tagIds) {
                                var oldTagIds = attachment.getDocTagIds();
                                var newTagIds = _.union(oldTagIds, tagIds);
                                attachment.saveDocTags(newTagIds, {});
                            });
                        }
                    }
                }
            });
        } else if (this.getType() === 'health_maintenance') {
            var hm_name = this.getMetadata().name;
            el8.data.maintItemRules.softLoad();
            var hm = el8.data.maintItemRules.getByKey(hm_name);
            el8.appchart.refpanel.maint.showDialog(hm.getName(), hm.getId());

        } else if (this.getType() === 'handouts') {
            var searchTerm = this.getMetadata().searchTerm;

            el8.appshared.dialog.viewEducationalHandouts.show();
            if (searchTerm) {
                el8.appshared.dialog.viewEducationalHandouts.applySearch(searchTerm);
            }
        }
        else if (this.getType() === 'questionnaire') {
            var clinicalFormName = this.getMetadata().name;
            var form = el8.ptdata.clinicalForms.getByName(clinicalFormName);
            if (form) {
                var payload = { formId: form.getId(), source: 'care gap' };
                el8React.dispatch.openClinicalFormsDialog(payload);
            }
        }
    };


    /*
     * One of the user's possible responses to this CDS.
     * Each response can result in 0-N actions.
     */
    var _cdsResponseClass = function(spec) { this.populate(spec); };
    _cdsResponseClass.inheritsFrom(el8_Entity);

    _cdsResponseClass.addStringProperty('responseLabel');
    _cdsResponseClass.addModelSetProperty('resultingActions',
        function(spec) { return new _responseResultClass(spec); }, false, []);

    _cdsResponseClass.prototype.actOn = function(noteFormObj) {
        this.getResultingActions().forEach(function(a) {
            a.takeAction(noteFormObj);
        });
    };


    /*
     * The CDS itself. This is usually linked to some populate management measure.
     */
    var _cdsClass = function(spec) {  this.populate(spec); };
    _cdsClass.inheritsFrom(el8_Entity);

    _cdsClass.addStringProperty('promptLabel');
    _cdsClass.addStringProperty('settingsLabel');

    // We'll use these as keys to lookup CDSs. Most measures have one,
    // some have multiple, but measures cannot share NQFs.
    _cdsClass.addStringProperty('nqfCode');

    // context where the CDS should show up (visit note/medorder form)
    _cdsClass.addProperty('targetContext', false, []);

    // This var won't mean anything if we have more than one responseOption.
    // But if we have exactly one, it tells us whether or not to immediately
    // use that response when the user clicks "Address" on a CDS.
    _cdsClass.addBoolean('skipOptionPrompt');
    _cdsClass.addModelSetProperty('responseOptions',
        function(spec) { return new _cdsResponseClass(spec); }, false, []);

    // These fields are not stored in the backend model but are injected by
    // the new CQM system in elation_clinical_reminders.make_old_style_cds().
    // TODO: eliminate this entire model when we transition to generating CDS
    // from the new reminders system directly.
    _cdsClass.addIntProperty('measureId');
    _cdsClass.addIntProperty('reminderIndex');

    // Wether we should show or not this CDS on the settings page (user, practice)
    _cdsClass.addBoolean('configurable');
    _cdsClass.addBoolean('isCaregap', false, false);

    _cdsClass.prototype.showInContext = function(currentContext) {
        if (!_.contains(["visitnote", "medorder"], currentContext)) {
            // right now, we only have 2 contexts: "visitnote" and "medorder"
            throw new Error(currentContext + ' is not a valid content');
        }
        return _.contains(this.getTargetContext(), currentContext);
    };

    /**
     * renderingContext provides context on whether the CDS should be shown
     * right now, we show CDS in 'visitnote' and 'medorder'
     * for the 'visitnote' context, we need the actual note to make the decision
     */
    _cdsClass.prototype.needsAction = function(renderingContext) {
        var that = this;
        var code = this.getNqfCode();

        if (el8.data.decisionSupports.isNqfCodeNeedingSupport(code) || this._isCaregap) {
            if (!this.showInContext(renderingContext['context'])) {
                return false;
            }

            // visitnote specific logic
            if (renderingContext['context'] === 'visitnote') {
                var note = renderingContext['relatedObject'];

                // check if the alert has been previously dismissed
                var noteAlert = note.getAlerts().getByNqfCode(code);
                if (!(!noteAlert || (noteAlert.getStatus() === 'ignored'))) {
                    return false;
                }
            }

            // If this is a v2 caregap, we won't have a measure matching the id, so we should just show this gap.
            if (this._isCaregap) {
                return true;
            }

            // due-date logic
            var reminderInfo = el8.appchart.cqmRefresh.cqmStatus.reminders[this.getMeasureId()];
            if (!reminderInfo) {
                return true;
            }

            var now = el8.appchart.cqmRefresh.getReportingDate();
            // Run through all the reminders to see if any trigger on the due date
            return _.some(reminderInfo.spec.reminders, function(reminder) {
                var dueInfo = el8.shared.util.cqm.getReminderItemDueInfo(reminder,
                    el8.appchart.cqmRefresh.cqmStatus.results[that.getMeasureId()].timelapse_map, now);

                if (dueInfo.dueInfo === null) {
                    return true;  // No due date means we should trigger
                }

                var dueDates = _.chain(dueInfo.dueInfo).values().pluck(1).value();

                // Run through all the due dates to see if any overlap with current datetime
                return _.some(dueDates, function (due) {
                    return due === null ||
                        ((due.dueStartDate === null || due.dueStartDate <= now) &&
                         (due.dueEndDate === null || due.dueEndDate > now));
                });
            });
        }
        return false;
    };

    var that = new el8_EntitySet({
        model: function(spec) {
            return new _cdsClass(spec);
        },
        key: 'nqfCode',
        urlLoad: function() {
            if(el8Globals.APP == 'chart' && el8Globals.PATIENT_ID) {
                // default noteDate
                var now = new Date(el8.appchart.cqmRefresh.getReportingDate());

                // attempt to set visitNote date as noteDate
                var noteDate = el8.appchart.mgr.notes.getNoteDate() || now;
                var noteDateStr = noteDate.getYear() + "-" + (noteDate.getMonth() + 1) + "-" + noteDate.getDate();
                return el8.service.urls.get('patientApplicableCDS', [noteDateStr]);

            } else if (el8Globals.APP == 'settings') {
                return el8.service.urls.get('decisionSupports', [true]);

            } else {
                return el8.service.urls.get('decisionSupports');
            }
        }
    });

    that.needCQMResultsRefresh = true;
    el8.appchart.cqmRefresh.register({
        updateCb: function(url, statusChanged) {
            if(statusChanged) {
                that.needCQMResultsRefresh = true;
            }
        }
    });

    that._indicatorsByNqfCode = {};
    that._isLoadingResults = false;
    that._successCallbacks = [];

    that.getIndicatorByNqfCode = function() {
        return that._indicatorsByNqfCode;
    };

    that.getAdditionalCareGapContext = function(nqfCode) {
        var cdsData = that.getIndicatorByNqfCode()[nqfCode];
        if (cdsData && cdsData.additional_context) {
            return cdsData.additional_context;
        }

        // Try and see if this is a v2 caregap.
        try {
            var caregap = that._all.filter(function (cds) { return cds._nqfCode === nqfCode; })[0];
            if (caregap && caregap._isCaregap && caregap.rawData.additional_context) {
                return caregap.rawData.additional_context;
            }
        } catch (e) {
            return null;
        }

        return null;
    };

    that.isNqfCodeNeedingSupport = function(nqfCode) {
        var cdsData = that.getIndicatorByNqfCode()[nqfCode];
        if (cdsData) {
            return cdsData.needs_support;
        }
        return false;
    };

    that.updateCdsIndicators = function(successCb, async) {
        that._successCallbacks.push(successCb);

        if(that._isLoadingResults) {
            return;
        }

        if(that.needCQMResultsRefresh) {
            // avoid making multiple calls to CDS if they haven't changed
            that.needCQMResultsRefresh = false;
            that._isLoadingResults = true;

            var year = el8.appchart.cqmRefresh.getReportingYear();
            $.el8_ajax({
                url: el8.service.urls.get('patientCds', [year]),
                type: 'GET',
                async: async,
                success: function(data) {
                    var frozenCallbacks = that._successCallbacks;
                    that._isLoadingResults = false;

                    that._indicatorsByNqfCode = data;
                    execSuccessCallbacks(frozenCallbacks);

                },
                error_override: function() {
                    that._isLoadingResults = false;
                }
            });
        }
        else {
            execSuccessCallbacks();
        }
    };

    function execSuccessCallbacks(callbacks) {
            _.each(callbacks || that._successCallbacks, function(fn) { fn(); });
            that._successCallbacks = [];
    }

    /**
     * renderingContext is a dict that provides information on where
     * this CDS data feed is used
     * right now, we show CDS in visit notes and med order form
     * this context is needed because we have some CDS that only shows up in
     * the med order form (e.x. high-risk meds for elderly)
     */
    that.getFeedIndex = function(successCb, renderingContext, async) {
        var resultFn = function() {
            var index = that.all()
                .filter(function(a) {
                    return a.needsAction(renderingContext);
                }).map(function(m) {
                    return {
                        id: m.getId(),
                        model_class: m.getModelClass()
                    };
                });
            if (successCb) { successCb(index); }
        };

        that.updateCdsIndicators(resultFn, async);
    };

    return that;

})();
